module.exports = __webpack_public_path__ + "img/101.2.da4ada89.png";